import type { AdminJsonComponentConfig } from '@apps/websiteCustomJsonComponents/types';
import { createLazyComponentFromNamedExport } from '@shared/utils/createLazyComponent';
import { GeneralScheduleGrabber } from './components/GeneralScheduleSidebar';
import { GENERAL_SCHEDULE_SCHEMA_URL, GENERAL_SCHEDULE_COMPONENT_TYPE } from './GeneralSchedule.constants';

// Lazy load view components
const GeneralScheduleAdd = createLazyComponentFromNamedExport(
  () => import(/* webpackChunkName: "content/websiteEditorGeneralScheduleAdd" */ './components/GeneralScheduleSidebar'),
  'GeneralScheduleAdd',
);

const GeneralScheduleEdit = createLazyComponentFromNamedExport(
  () => import(/* webpackChunkName: "content/websiteEditorGeneralScheduleEdit" */ './components/GeneralScheduleEdit'),
  'GeneralScheduleEdit',
);

// Add this object to CUSTOM_JSON_COMPONENT_TYPES in
// src/apps/websiteCustomJsonComponents/config.ts
export const GeneralScheduleConfig: AdminJsonComponentConfig = {
  schemaUrl: GENERAL_SCHEDULE_SCHEMA_URL,
  componentType: GENERAL_SCHEDULE_COMPONENT_TYPE,
  adminSidebarComponent: {
    addComponentView: GeneralScheduleAdd,
    dragComponentView: GeneralScheduleGrabber,
    editComponentView: GeneralScheduleEdit,
    createComponentView: GeneralScheduleEdit,
  },
};
